import React from "react";
import Blog_55 from "../component/Blog_55";
function Blog_55_container() {
  return <Blog_55 />;
}

export default Blog_55_container;
